"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Skeleton = void 0;
var react_1 = __importDefault(require("react"));
var Skeleton_module_scss_1 = __importDefault(require("./Skeleton.module.scss"));
var Skeleton = function (_a) {
    var _b = _a.width, width = _b === void 0 ? '100%' : _b, _c = _a.height, height = _c === void 0 ? 20 : _c, _d = _a.count, count = _d === void 0 ? 1 : _d;
    return (react_1.default.createElement(react_1.default.Fragment, null, Array.from({ length: count }).map(function (_, i) { return (react_1.default.createElement("div", { key: i, className: Skeleton_module_scss_1.default.skeleton, style: { width: width, height: height } })); })));
};
exports.Skeleton = Skeleton;
